import category1Img from '../../assets/img/Aurus/category-list/category1.png';
import category2Img from '../../assets/img/Aurus/category-list/category2.png';
import category3Img from '../../assets/img/Aurus/category-list/category3.png';

// src/components/Aurus/CategoryList.jsx
const categories = [
  {
    name: "Бытовые сплит-системы",
    img: category1Img,
    link: "#",
  },
  {
    name: "Водонагревательная техника",
    img: category2Img,
    link: "#",
   // C:\newCRM\evo7\src\assets\img\Aurus\category-list\category1.png
   // src\assets\img\Aurus\category-list\category2.png
  },
  {
    name: "Тепловая техника",
    img: category3Img,
    link: "#",
  },
];

const CategoryList = () => {
  return (
    <section className="category-list">
      <div className="wrapper">
        {categories.map((category, idx) => (
          <a href={category.link} className="category-list__item" key={idx}>
            <img src={category.img} alt="" className="category-list__img" />
            <span className="category-list__name">{category.name}</span>
          </a>
        ))}
      </div>
    </section>
  );
};

export default CategoryList;
